import api from "../services/AccountService";
import { userSession } from "../constants/UserConstant";
import ClientError from '../utils/errorLogger';
import dayjs from "dayjs";

const userData = userSession.userData;


//Landing Screen
export const fetchDamData = async (flag) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Flag: flag
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/DAMLandingScreen`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const fetchAssetDetails = async (obj) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: obj?.PARAMCODE
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/GetAssetDetails`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const updateCartData = async (obj) => {
    
    let dt = obj?.cart || obj;
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: dt?.PARAMCODE,
        Flag: obj.flag,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/AddRemoveCard`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const GetCartData = async () => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/ShowCardData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const SaveCartData = async (obj) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        CARTID: obj?.CARTID,
        CARTNAME: obj.CARTNAME
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SaveCardData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const CommonBlobDetails = async (flag) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,

    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {

        const response = await api.post(
            `/CommonMethods/CommonBlobDetails`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
}
export const UploadSasWise = async (objdt) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        BlobUrl: objdt?.baseUrl + userData.CLIENTID.toLowerCase() + "/" + objdt.containerName + "/" + objdt.filename + objdt.blobsastoken,
        originFile: objdt?.filename,
        imgStream: objdt?.pdfBase64?.split(",")[1],
    }
    const data = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData)
    }
    try {
        return await api.post('/CommonMethods/UploadSasWise', JSON.stringify(data))
    }
    catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
}

export const GetpendingVdr = async (cartID) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        CARTID: cartID
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/GetpendingVdr`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const InrtBlobDetails = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: obj.assetid,
        REQID: "",
        VENDORID: "",
        IPADDRESS: obj.IPaddress,
        SOURCEFLG: 1,
        FILENAME: obj.filename,
        FILEPATH: obj.bloburl
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/InsrtBlobDwnld`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const ConfigFormUpldAst = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/ConfigFormUpldAsset`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const PropcomChoice = async () => {

    let choice = ["PHRBU", "PHRMED", "PHRCH", "PHRTYPE", "PHRCAMP", "PHRALLBU", "LANG", "USEAS", "REQTYP", "CREATIVE", "PHRTAG"];
    let keys = [{ "PHRBU": "Country", "PHRMED": "Media", "PHRCH": "Channel", "PHRTYPE": "Type", "PHRCAMP": "CampaignName", "PHRALLBU": "OwnerDivision", "LANG": "Language", "USEAS": "UseAs", "REQTYP": "Requesttype", "CREATIVE": "CreativeAgency", "PHRTAG": "TAGMASTER" }];
    let result = {};

    for (const item of choice) {
        const postData = {
            CLIENTID: userData.CLIENTID,
            EMPCODE: userData.EMPCODE,
            choice: item,
        };

        const apiDatas = {
            key: "",
            dataobj: "",
            jsonstring: JSON.stringify(postData),
        };

        try {
            const response = await api.post(
                `/CommonMethods/BindBU`,
                JSON.stringify(apiDatas)
            );
            result[keys?.[0]?.[item]] = response?.data?.ResultSet?.Table1 || [];
        } catch (error) {
            console.error(`Error fetching ${item}:`, error);
            return ClientError(
                error.message,
                window.location,
                `${error.config?.baseURL}${error.config?.url}`,
                error.response
            );
        }
    }

    return result;
};
export const ChoiceOnChnage = async (obj) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        BUCODE: obj?.BU || userData.BU,
        choice: obj.choice,
        GEOLOCCODE: obj?.param || 0
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };

    try {
        const response = await api.post(
            `/CommonMethods/BindBU`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};
export const SaveDraftAssets = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Flag: obj.flag,
        SaveSubData: obj.objResult,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };

    try {
        const response = await api.post(
            `/DAM/SaveDraftAssets`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const SearchAsset = async (searchInput) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Flag: searchInput,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };

    try {
        const response = await api.post(
            `/DAM/SearchAsset`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const GetHdrConfig = async (searchInput) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };

    try {
        const response = await api.post(
            `/DAM/GetHdrConfig`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};


export const showAssesetsData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        AssetID: params?.PARAMCODE,
        // ANNOTEFLAG:  params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0
        // ANNOTEFLAG: params?.pageFlag === true ?
        //     (params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0) :
        //     (userData?.ROLECODE === 9 ? (params?.ANNOTEFLAG) : 0),
        // ANNOTEFLAG: (params?.pageFlag !== false && params?.pageFlag !== undefined)
        //     ? (params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0)
        //     : (userData?.ROLECODE === 9 ? (params?.ANNOTEFLAG) : 1)

        ANNOTEFLAG: params?.UploadFilePage == 1
            ? null
            : (params?.pageFlag !== false && params?.pageFlag !== undefined)
                ? (params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0)
                : (userData?.ROLECODE === 9
                    ? params?.ANNOTEFLAG
                    : (params?.CardID === 2 || params?.CardID === 3 ? 0 : 1)
                )
    };



    const apiDatas = {

        key: "",

        dataobj: "",

        jsonstring: JSON.stringify(postData),

    };



    try {

        const response = await api.post(

            `/DAM/ShowAssesetsData`,

            JSON.stringify(apiDatas)

        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(

            error.message,

            window.location,

            `${error.config?.baseURL}${error.config?.url}`,

            error.response

        );

    }

};

export const SubVendorReqDt = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        ...obj
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SubVendorReqdtl`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const SubAfterAnnoData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        SaveCampData: obj?.saveData || [],
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SubmitAfterAprRej`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const CampCreationSave = async (obj) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Brand: obj?.Brand || "",
        fromDate: obj?.fromDate || "",
        toDate: obj?.toDate || "",
        CampName: obj?.CampName || "",
        SaveCampData: obj.SaveSubData,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };

    try {
        const response = await api.post(
            `/DAM/CampCreationSave`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};
export const FetchReqtData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        REQID: obj.REQID,
        ANNOTEFLAG: obj.DFLAG,
        AssetID: obj.ASTID,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/FetchReqtData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const BU_BrandBasedData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Brand: obj.BrandName,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/BU_BrandBasedData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const AccessPrivilegeGrid = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/AccessPrivilegeGrid`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const AccessPrivilegSave = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        SaveCampData: obj?.saveData || [],
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/AccessPrivilegSave`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};


export const SaveSubmitData = async (params) => {


    const postData = {

        CLIENTID: userData.CLIENTID,

        Repcode: userData.EMPCODE,

        action: params.Action,

        comment: params.comment,

        AssetID: params.AssetID,
        // ANNOTEFLAG: userData?.ROLECODE === 9 ? (params?.ANNOTEFLAG) : 0,
        // ANNOTEFLAG: (params?.pageFlag !== false && params?.pageFlag !== undefined)
        // ? (params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0)
        // : (userData?.ROLECODE === 9
        //     ? params?.ANNOTEFLAG
        //     : (params?.CardID === 2 || params?.CardID === 3 ? 0 : 1)
        // ),
        ANNOTEFLAG: (params?.pageFlag !== false && params?.pageFlag !== undefined)
            ? (params?.ANNOTEFLAG || params?.ANNOVATEFLAG || 0)
            : 0,

        resolvedFlag: params?.resolvedFlag,
        FILEPATH: params?.FILEURL,
        FILENAME: params?.FILENAME,
        THUMNAILURL: params?.THUMBURL,
        FlagInt: params.InitResolved

        // AssetID: 1060,

        // AssetID: 1061,

    };

    const anota = { AnnovateData: params.annotations }



    const apiDatas = {

        key: "",

        dataobj: "",

        jsonstring: JSON.stringify(postData) + "~" + JSON.stringify(anota),

    };



    try {

        const response = await api.post(

            `/DAM/saveSubmitData`,

            JSON.stringify(apiDatas)

        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(

            error.message,

            window.location,

            `${error.config?.baseURL}${error.config?.url}`,

            error.response

        );

    }

};

export const GetRequestData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: obj?.EMPCODE || userData.EMPCODE,
        BUCODE: obj?.BU || userData.BU,
        TRCODE: obj?.Taskforce || 0,
        TYPE: obj?.Type || 0,
        SUBTYPE: obj?.SubType || 0,
        choice: obj.choice,
        FlagInt: obj?.RequestType || 0,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/RequestMasterdetails`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const SubRequestData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        ...obj
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SubRequestdetails`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const ShareDropData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        BU: obj.COUNTRY,
        TfCode: obj.TASKFORCE,
        Type: obj.TYPE,
        SubType: obj.SUBTYPE,
        // Choice: userData.Choice,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/ShareDropData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const SaveShareData = async (obj) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        AstID: obj.AssetID,
        Vendor: obj.Vendor,
        UserID: obj.user,
        FromDate: obj.fromDate ? dayjs(obj.fromDate).format('DD/MM/YYYY') : null,
        ToDate: obj.toDate ? dayjs(obj.toDate).format('DD/MM/YYYY') : null,
        Access: obj.Access ? obj.Access.join(',') : '',
        ShareType: obj.Share,
        Mode: obj.mode,
        Reason: obj.Reason,
        BlobUrl: obj.BlobUrl,
        ShareParamsname: obj.shareSelectedType
        // Choice: userData.Choice,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SaveShare`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const DeleteAssest = async (param) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        REPCODE: userData.EMPCODE,
        AssetID: param.AssetID,
        Flag: param.Flag,
        ListFilePath: param.ListFilePath,
        ReqFlag: param?.ReqFlag || ''
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/DeleteAssest`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const CheckOutData = async (param) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        REPCODE: userData.EMPCODE,
        AssetID: param,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/CheckOutData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};
export const UpdateLike = async (obj) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: obj.PARAMCODE,
        Flag: obj.LikeDisLikeFlag
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/UpdateLike`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};


export const SaveAttributesData = async (params) => {


    const postData = {

        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AstID: params.AssetID,
        SaveSubData: params?.finalString ? [params.finalString] : [],
        Flag: params?.EDITFLAG || 2
    };
    // const anota = { AnnovateData: params.annotations }
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SaveEditAttribute`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};




export const saveUserData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Role: params.Role,
        Photo: params.Photo,
        Email: params.Email,
        Address: params.Address,
        Name: params.CampName,
        MobileNo: params.MobileNo,
        // params.Taskforce
        TF: Array.isArray(params.Taskforce)
            ? params.Taskforce.filter(item => item).join(',') // removes empty, null, undefined
            : params.Taskforce || 0,
        Brand: Array.isArray(params.Brand)
            ? params.Brand.filter(item => item).join(',') // removes empty, null, undefined
            : params.Brand || 0,
        Speciality: Array.isArray(params.Speciality)
            ? params.Speciality.filter(item => item).join(',') // removes empty, null, undefined
            : params.Speciality || 0,
        Bu: Array.isArray(params.BU)
            ? params.BU.filter(item => item).join(',') // removes empty, null, undefined
            : params.BU || 0,
        //Bu: params.BU,

    };
    // const anota = { AnnovateData: params.annotations }
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/SaveUserData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const UserData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };
    // const anota = { AnnovateData: params.annotations }
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/UserData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const UserUpdate = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        UserID: params
    };
    // const anota = { AnnovateData: params.annotations }
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/UserUpdate`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const validateFileDetails = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        ...params
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/ValidateContentAPI`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};

export const SaveUpdateData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        Role: params.Role,
        Photo: params.Photo,
        Email: params.Email,
        Address: params.Address,
        Name: params.CampName,
        MobileNo: params.MobileNo,
        // params.Taskforce
        TF: Array.isArray(params.Taskforce)
            ? params.Taskforce.filter(item => item).join(',') // removes empty, null, undefined
            : params.Taskforce || 0,
        Brand: Array.isArray(params.Brand)
            ? params.Brand.filter(item => item).join(',') // removes empty, null, undefined
            : params.Brand || 0,
        Speciality: Array.isArray(params.Speciality)
            ? params.Speciality.filter(item => item).join(',') // removes empty, null, undefined
            : params.Speciality || 0,
        Bu: Array.isArray(params.BU)
            ? params.BU.filter(item => item).join(',') // removes empty, null, undefined
            : params.BU || 0,
        UserID: params?.UserID

    };
    // const anota = { AnnovateData: params.annotations }
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/saveUpdateData`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response
        );
    }
};
export const AutoFillAccessControl = async () => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),
    };
    try {
        const response = await api.post(
            `/DAM/AutoFillAccessControl`,
            JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    }
};

export const ShowHistoryData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        AssetID: params?.PARAMCODE,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/ShowHistoryData`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};

//DM UPLOAD
export const fetchTemplate = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/GetTemplateList`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};

export const fetchTicketNo = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/GenerateTicketNo`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};
export const fetchExcelData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        Reportid: params
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/GetTemplateData`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};

export const SaveUploadData = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        ...params
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/SaveUploadData`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};

export const GetUploadDataGrid = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        Tmpid: params
    };

    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };

    try {

        const response = await api.post(
            `/DAM/GetUploadDataGrid`, JSON.stringify(apiDatas)
        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );

    }

};
export const fetchExcelData1 = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        Tmpid: params?.TemplateId,
        TicketNo: params?.TicketNo,
        Flag: params?.Flag,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };
    try {
        const response = await api.post(
            `/DAM/GetExcProcExcel`, JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );
    }

};
export const fetchTicketHistory = async (params) => {
    const postData = {
        CLIENTID: userData.CLIENTID,
        Repcode: userData.EMPCODE,
        Tmpid: params?.TemplateId,
        TicketNo: params?.TicketNo,
    };
    const apiDatas = {
        key: "",
        dataobj: "",
        jsonstring: JSON.stringify(postData),

    };
    try {
        const response = await api.post(
            `/DAM/GetTicketHistory`, JSON.stringify(apiDatas)
        );
        return response
    } catch (error) {
        console.error(`Error fetching`, error);
        return ClientError(
            error.message,
            window.location,
            `${error.config?.baseURL}${error.config?.url}`,
            error.response

        );
    }
};

export const GetCycleStages = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: params?.AssetID,

       
    };



    const apiDatas = {

        key: "",

        dataobj: "",

        jsonstring: JSON.stringify(postData),

    };



    try {

        const response = await api.post(

            `/DAM/GetApprovalCycleStages`,

            JSON.stringify(apiDatas)

        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(

            error.message,

            window.location,

            `${error.config?.baseURL}${error.config?.url}`,

            error.response

        );

    }

};
export const getCycleDDL = async (params) => {

    const postData = {
        CLIENTID: userData.CLIENTID,
        EMPCODE: userData.EMPCODE,
        AssetID: params?.AssetID,
        action: params?.PASS_NO

    };



    const apiDatas = {

        key: "",

        dataobj: "",

        jsonstring: JSON.stringify(postData),

    };



    try {

        const response = await api.post(

            `/DAM/getApprovalCycleDDL`,

            JSON.stringify(apiDatas)

        );

        return response

    } catch (error) {

        console.error(`Error fetching`, error);

        return ClientError(

            error.message,

            window.location,

            `${error.config?.baseURL}${error.config?.url}`,

            error.response

        );

    }

};
// END DM UPLOAD